import { Navigate } from '@tanstack/react-router'
import { useContext } from 'react'
import { OriginContext } from '@utils'

export default function WorkflowsRedirect() {
  const origin = useContext(OriginContext)
  if (origin == null) throw new Error('Origin not found...')
  if ('missingFields' in origin && origin.missingFields) {
    return (
      <Navigate
        to="/submit"
        search={{
          success: false,
          workflow: 'loanNumber' in origin ? origin.loanNumber : undefined,
          errors: origin.missingFields,
        }}
      />
    )
  }

  if ('entityId' in origin && typeof origin.entityId === 'string') {
    return (
      <Navigate
        to="/additional-services/workflows/$loanNumber"
        params={{ loanNumber: origin.entityId }}
        search={search => search}
      />
    )
  }

  throw new Error('Origin does not have entityId')
}
